var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", [_c("el-form", {
    attrs: {
      inline: true,
      "label-width": "90px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "服务器列表",
      "label-width": "100px"
    }
  }, [_c("server-list", {
    model: {
      value: _vm.searchInfo.server_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "server_id", $$v);
      },
      expression: "searchInfo.server_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "角色ID：",
      "label-width": "100px"
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "180px",
      height: "38px"
    },
    model: {
      value: _vm.searchInfo.role_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "role_id", $$v);
      },
      expression: "searchInfo.role_id"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "角色名："
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "180px",
      height: "38px"
    },
    model: {
      value: _vm.searchInfo.role_name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "role_name", $$v);
      },
      expression: "searchInfo.role_name"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "玩家等级："
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "180px",
      height: "38px"
    },
    model: {
      value: _vm.searchInfo.role_level,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "role_level", $$v);
      },
      expression: "searchInfo.role_level"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "VIP等级："
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "180px",
      height: "38px"
    },
    model: {
      value: _vm.searchInfo.role_vip_level,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "role_vip_level", $$v);
      },
      expression: "searchInfo.role_vip_level"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "日期："
    }
  }, [[_c("data-options", {
    attrs: {
      clearable: false
    },
    model: {
      value: _vm.formData,
      callback: function callback($$v) {
        _vm.formData = $$v;
      },
      expression: "formData"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "回复时间："
    }
  }, [[_c("data-options", {
    attrs: {
      clearable: true
    },
    model: {
      value: _vm.replyTime,
      callback: function callback($$v) {
        _vm.replyTime = $$v;
      },
      expression: "replyTime"
    }
  })]], 2), _c("el-form-item", {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c("el-button", {
          attrs: {
            status: "primary",
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.searchEvent();
            }
          }
        }, [_vm._v("查询 ")])];
      },
      proxy: true
    }])
  })], 1)], 1), _c("div", [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      stripe: "",
      height: "600",
      "cell-class-name": _vm.cellStyle,
      "header-cell-style": {
        background: "#eef1f6",
        color: "#606266"
      }
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "区服",
      width: "160",
      prop: "serverId"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.serverList[scope.row.server_id]) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "渠道",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.channelMap[scope.row.channel_id]) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "角色ID",
      width: "150",
      prop: "role_id"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "角色名",
      width: "100",
      prop: "role_name"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "玩家等级",
      width: "100",
      prop: "role_level"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "VIP等级",
      width: "100",
      prop: "role_vip_level"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "建议内容",
      "min-width": "180",
      prop: "suggest_content"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "建议时间",
      width: "100",
      prop: "suggest_time"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "回复状态",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.reply_status === 3 ? _c("span", {
          staticStyle: {
            color: "#67C23A"
          }
        }, [_vm._v(" " + _vm._s(_vm.replyList[scope.row.reply_status]) + " ")]) : _c("span", {
          staticStyle: {
            color: "#F56C6C"
          }
        }, [_vm._v(" " + _vm._s(_vm.replyList[scope.row.reply_status]) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "最后回复用户",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.last_reply_user == "" ? "无" : scope.row.last_reply_user) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            size: "small",
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.checkBtn(scope.row);
            }
          }
        }, [_vm._v(" 回复/查看 ")]), _c("el-button", {
          attrs: {
            size: "small",
            type: "danger"
          },
          on: {
            click: function click($event) {
              return _vm.deleteBtn(scope.row.ID);
            }
          }
        }, [_vm._v(" 删除 ")])];
      }
    }])
  })], 1)], 1), _c("el-pagination", {
    style: {
      float: "right",
      padding: "20px"
    },
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "page-sizes": [5, 30, 50, 100, 500],
      total: _vm.total,
      layout: "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  }), _c("div", [_vm.dialogFormVisible ? _c("el-dialog", {
    attrs: {
      title: "回复建议",
      visible: _vm.dialogFormVisible,
      center: ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogFormVisible = $event;
      }
    }
  }, [_c("feed-back-comp", {
    staticStyle: {
      "max-height": "550px",
      "overflow-y": "auto"
    },
    attrs: {
      form: _vm.form,
      serverList: _vm.serverList
    },
    on: {
      backBtn: _vm.backBtn
    }
  })], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };